import { Pipe, PipeTransform } from '@angular/core';
/**
  * CharPipe
  *
  * A pipe to transform a string and return its first character (capitalize).
  */
@Pipe({ name: 'char' })
export class CharPipe implements PipeTransform {
  /**
  * Transforms passed in value and return first character of value.
  *
  * @param {string} name The string to be transformed.
  * @return {string} Returns first character of the passed in value.
  */
  transform(name: string): string {
    return `${name.charAt(0)}.`.toUpperCase();
  }
}
